import { Box } from '@mui/system';

const CardCarrusel = ({ img, scale = 1 }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={img}
        alt="logo"
        style={{
          width: '100%',
          maxWidth: '200px',
          height: '120px',
          objectFit: 'contain',
          transform: `scale(${scale})`,
          transition: 'transform 0.3s ease-in-out',
        }}
      />
    </Box>
  );
};

export default CardCarrusel;
